// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/@gol-smiles/tangerina-assets/dist/icons/tgr-icons.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/@gol-smiles/tangerina-tokens/dist/web/brands/gol/themes/default_theme/index.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/@gol-smiles/tangerina-tokens/dist/web/brands/smiles/themes/default_theme/index.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@gol-smiles/tangerina-assets/dist/icons/tgr-icons.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("@gol-smiles/tangerina-assets/dist/fonts/GOLSansDisplay-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("@gol-smiles/tangerina-assets/dist/fonts/GOLSansDisplay-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("@gol-smiles/tangerina-assets/dist/fonts/GOLSansDisplay-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("@gol-smiles/tangerina-assets/dist/fonts/GOLSansDisplay-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("@gol-smiles/tangerina-assets/dist/fonts/Nunito-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("@gol-smiles/tangerina-assets/dist/fonts/Nunito-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("@gol-smiles/tangerina-assets/dist/fonts/Nunito-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("@gol-smiles/tangerina-assets/dist/fonts/Nunito-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("@gol-smiles/tangerina-assets/dist/fonts/NunitoSans-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("@gol-smiles/tangerina-assets/dist/fonts/NunitoSans-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("@gol-smiles/tangerina-assets/dist/fonts/NunitoSans-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("@gol-smiles/tangerina-assets/dist/fonts/NunitoSans-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Tangerina Design System - Fontes e Ícones */

/* Importações dos tokens e ícones */

/* Definição das fontes de ícones */
@font-face {
  font-family: 'tgr-icons';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
    format('truetype');
}

/* Definição das fontes GOL Sans Display */
@font-face {
  font-family: 'GOL Sans Display';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___})
    format('truetype');
  font-weight: 700;
}

@font-face {
  font-family: 'GOL Sans Display';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___})
    format('truetype');
  font-weight: 500;
}

@font-face {
  font-family: 'GOL Sans Display';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___})
    format('truetype');
  font-weight: 400;
}

@font-face {
  font-family: 'GOL Sans Display';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___})
    format('truetype');
  font-weight: 600;
}

/* Definição das fontes Nunito */
@font-face {
  font-family: 'Nunito';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___})
    format('truetype');
  font-weight: 700;
}

@font-face {
  font-family: 'Nunito';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___})
    format('truetype');
  font-weight: 500;
}

@font-face {
  font-family: 'Nunito';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___})
    format('truetype');
  font-weight: 400;
}

@font-face {
  font-family: 'Nunito';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___})
    format('truetype');
  font-weight: 600;
}

/* Definição das fontes Nunito Sans */
@font-face {
  font-family: 'Nunito Sans';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___})
    format('truetype');
  font-weight: 700;
}

@font-face {
  font-family: 'Nunito Sans';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___})
    format('truetype');
  font-weight: 500;
}

@font-face {
  font-family: 'Nunito Sans';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___})
    format('truetype');
  font-weight: 400;
}

@font-face {
  font-family: 'Nunito Sans';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___})
    format('truetype');
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/assets/tangerina-fonts.css"],"names":[],"mappings":"AAAA,8CAA8C;;AAE9C,oCAAoC;;AAKpC,mCAAmC;AACnC;EACE,wBAAwB;EACxB;sBACoB;AACtB;;AAEA,0CAA0C;AAC1C;EACE,+BAA+B;EAC/B;sBACoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B;sBACoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B;sBACoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B;sBACoB;EACpB,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,qBAAqB;EACrB;sBACoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB;sBACoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB;sBACoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB;sBACoB;EACpB,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,0BAA0B;EAC1B;sBACoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B;sBACoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B;sBACoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B;sBACoB;EACpB,gBAAgB;AAClB","sourcesContent":["/* Tangerina Design System - Fontes e Ícones */\n\n/* Importações dos tokens e ícones */\n@import '@gol-smiles/tangerina-assets/dist/icons/tgr-icons.css';\n@import '@gol-smiles/tangerina-tokens/dist/web/brands/gol/themes/default_theme/index.css';\n@import '@gol-smiles/tangerina-tokens/dist/web/brands/smiles/themes/default_theme/index.css';\n\n/* Definição das fontes de ícones */\n@font-face {\n  font-family: 'tgr-icons';\n  src: url('@gol-smiles/tangerina-assets/dist/icons/tgr-icons.ttf')\n    format('truetype');\n}\n\n/* Definição das fontes GOL Sans Display */\n@font-face {\n  font-family: 'GOL Sans Display';\n  src: url('@gol-smiles/tangerina-assets/dist/fonts/GOLSansDisplay-Bold.ttf')\n    format('truetype');\n  font-weight: 700;\n}\n\n@font-face {\n  font-family: 'GOL Sans Display';\n  src: url('@gol-smiles/tangerina-assets/dist/fonts/GOLSansDisplay-Medium.ttf')\n    format('truetype');\n  font-weight: 500;\n}\n\n@font-face {\n  font-family: 'GOL Sans Display';\n  src: url('@gol-smiles/tangerina-assets/dist/fonts/GOLSansDisplay-Regular.ttf')\n    format('truetype');\n  font-weight: 400;\n}\n\n@font-face {\n  font-family: 'GOL Sans Display';\n  src: url('@gol-smiles/tangerina-assets/dist/fonts/GOLSansDisplay-SemiBold.ttf')\n    format('truetype');\n  font-weight: 600;\n}\n\n/* Definição das fontes Nunito */\n@font-face {\n  font-family: 'Nunito';\n  src: url('@gol-smiles/tangerina-assets/dist/fonts/Nunito-Bold.ttf')\n    format('truetype');\n  font-weight: 700;\n}\n\n@font-face {\n  font-family: 'Nunito';\n  src: url('@gol-smiles/tangerina-assets/dist/fonts/Nunito-Medium.ttf')\n    format('truetype');\n  font-weight: 500;\n}\n\n@font-face {\n  font-family: 'Nunito';\n  src: url('@gol-smiles/tangerina-assets/dist/fonts/Nunito-Regular.ttf')\n    format('truetype');\n  font-weight: 400;\n}\n\n@font-face {\n  font-family: 'Nunito';\n  src: url('@gol-smiles/tangerina-assets/dist/fonts/Nunito-SemiBold.ttf')\n    format('truetype');\n  font-weight: 600;\n}\n\n/* Definição das fontes Nunito Sans */\n@font-face {\n  font-family: 'Nunito Sans';\n  src: url('@gol-smiles/tangerina-assets/dist/fonts/NunitoSans-Bold.ttf')\n    format('truetype');\n  font-weight: 700;\n}\n\n@font-face {\n  font-family: 'Nunito Sans';\n  src: url('@gol-smiles/tangerina-assets/dist/fonts/NunitoSans-Medium.ttf')\n    format('truetype');\n  font-weight: 500;\n}\n\n@font-face {\n  font-family: 'Nunito Sans';\n  src: url('@gol-smiles/tangerina-assets/dist/fonts/NunitoSans-Regular.ttf')\n    format('truetype');\n  font-weight: 400;\n}\n\n@font-face {\n  font-family: 'Nunito Sans';\n  src: url('@gol-smiles/tangerina-assets/dist/fonts/NunitoSans-SemiBold.ttf')\n    format('truetype');\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
